import { api } from './api'

const BASE = '/company-availability'

/**
 * Servicio para los endpoints de disponibilidad de la empresa.
 * Cubre settings generales, horario semanal (weekly) y excepciones por fecha (overrides).
 */
export const availabilityService = {
  // ─── Settings ────────────────────────────────────────────────────────

  /** @param {string} [tenantId] - empresa distinta a la activa (onboarding viendo otra empresa propia) */
  async getSettings(tenantId) {
    try {
      const data = await api.get(`${BASE}/settings`, true, tenantId ? { tenantId } : {})
      return data
    } catch (error) {
      console.error('[AvailabilityService] getSettings:', error)
      throw error
    }
  },

  async updateSettings(payload, tenantId) {
    try {
      const data = await api.put(`${BASE}/settings`, payload, true, tenantId ? { tenantId } : {})
      return data
    } catch (error) {
      console.error('[AvailabilityService] updateSettings:', error)
      throw error
    }
  },

  // ─── Weekly ──────────────────────────────────────────────────────────

  /** @param {string} [tenantId] - ver getSettings */
  async getWeekly(tenantId) {
    try {
      const data = await api.get(`${BASE}/weekly`, true, tenantId ? { tenantId } : {})
      return data
    } catch (error) {
      console.error('[AvailabilityService] getWeekly:', error)
      throw error
    }
  },

  async updateWeekly(payload, tenantId) {
    try {
      const data = await api.put(`${BASE}/weekly`, payload, true, tenantId ? { tenantId } : {})
      return data
    } catch (error) {
      console.error('[AvailabilityService] updateWeekly:', error)
      throw error
    }
  },

  // ─── Overrides (fechas específicas) ──────────────────────────────────

  async getOverrides() {
    try {
      const data = await api.get(`${BASE}/overrides`)
      return data
    } catch (error) {
      console.error('[AvailabilityService] getOverrides:', error)
      throw error
    }
  },

  async createOverride(payload) {
    try {
      const { data, status } = await api.postWithStatus(`${BASE}/overrides`, payload, true)
      return { data, httpStatus: status }
    } catch (error) {
      console.error('[AvailabilityService] createOverride:', error)
      throw error
    }
  },

  async updateOverride(id, payload) {
    try {
      const data = await api.put(`${BASE}/overrides/${id}`, payload)
      return data
    } catch (error) {
      console.error('[AvailabilityService] updateOverride:', error)
      throw error
    }
  },

  async deleteOverride(id) {
    try {
      const data = await api.delete(`${BASE}/overrides/${id}`)
      return data
    } catch (error) {
      console.error('[AvailabilityService] deleteOverride:', error)
      throw error
    }
  }
}
